const graphQLErrorParser = error => {
  const { graphQLErrors } = error;

  const graphQLError = graphQLErrors[0];

  return {
    hasErrors: () => !!graphQLError,
    parse: () => (
      {
        type: graphQLError.message?.extensions?.status_code,
        fields: null,
        message: graphQLError.message,
      }
    )
  };
};

export default graphQLErrorParser;
